"use client";
import dynamic from "next/dynamic";

export const ErrorReporter = dynamic(() => import("./error-reporter"));
